import React, { useEffect, useState } from "react";
import { utilityBillingList } from "../../utils/constants";
import Calendar24Months from "./Calendar24Months";

const UtilityBillingContract = ({
  handleBillingCycle,
  billingPeriod,
  updateUtilityDates,
  dcthreshold,
  projectStatusData,
  siteCreated,
  projectTypeValue
}) => {
  const [isDisable, setIsDisable] = useState(false);
  const [enableCustomDate, setEnableCustomDate] = useState(false);
  useEffect(() => {
    setIsDisable(billingPeriod?.billingType === "FIRST" ? true : false);
    setEnableCustomDate(billingPeriod?.billingType === "CUSTOM" ? true : false);
  }, [billingPeriod?.billingType]);
 
  return (
    <div className="row">
      <div className={`col-sm-12 ${
          (siteCreated && projectTypeValue !== "NMGaaS ETO")||
          projectStatusData?.projectStatus === "COMPLETED" ||
          projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
            ? "se-block-disabled not-allowed"
            : ""
        }`}>
        <se-block>
          <se-form-field
            label="Day Of Billing Cycle"
            required="true"
            type="select"
            className="form-control "
          >
            <select
              id="dayOfBillingCycle"
              className="form-control "
              name="billingType"
              value={billingPeriod?.billingType}
              onChange={handleBillingCycle}
            >
              {utilityBillingList.length > 0 &&
                utilityBillingList.map((cyleType) => (
                  <option value={cyleType.value} key={cyleType.label}>
                    {cyleType.label}
                  </option>
                ))}
            </select>
          </se-form-field>
          {billingPeriod?.billingType !== "CUSTOM" && (
            <>
              <se-form-field label="Billing Cycle Start Date" required="true">
                <div>
                  <input
                    className="form-control"
                    name="billingCycleStartDate"
                    value={billingPeriod?.fixDay}
                    maxLength="2"
                    type="text"
                    onChange={handleBillingCycle}
                    disabled={isDisable}
                  />
                  {(Number(billingPeriod?.fixDay) < 1 ||
                    Number(billingPeriod?.fixDay) > 28 ||
                    !/^\d+$/.test(billingPeriod.fixDay)) && (
                    <div
                      className={`${
                        Number(billingPeriod?.fixDay) < 1 ||
                        Number(billingPeriod?.fixDay) > 28 ||
                        !/^\d+$/.test(billingPeriod?.fixDay)
                          ? "invalid-feedback-custom"
                          : "hidden"
                      }`}
                    >
                      {"Date should be between 1-28"}
                    </div>
                  )}
                </div>
              </se-form-field>
            </>
          )}
        </se-block>
      </div>
      {enableCustomDate && (
        <div className="col-sm-12">
          <Calendar24Months
            updateUtilityDates={updateUtilityDates}
            billingPeriod={billingPeriod}
            projectStatusData={projectStatusData}
            siteCreated={siteCreated}
          />
        </div>
      )}
    </div>
  );
};

export default UtilityBillingContract;
